<style>
    .ivu-form-item-label{font-size: 16px!important;color: #4B4B4B!important;}
</style>
<template>
  <div class="contain">
    <page-head
      :title="title"
      :btn-list="btnList"
      :show-back="false"
      @handleBtn="handleBtn"
    ></page-head>
    <div class="content">
      <div class="toptitle box box_between ac"><span>基本信息</span><span @click="goedit">编辑</span></div>
      <div class="search">
        <i-form ref="search" :model="query">
          <row :gutter="80">
            <i-col span="6">
              <form-item label="地丘号" prop="landnum">
                <Input readonly
                  v-model="query.landnum"
                  clearable
                  placeholder="请输入"
                />
              </form-item>
            </i-col>
            <i-col span="6">
              <form-item label="名称" prop="landnumname">
                <Input readonly
                  v-model="query.landnumname"
                  clearable
                  placeholder="请输入"
                />
              </form-item>
            </i-col>
            <i-col span="6">
              <form-item label="行政区域">
                <Cascader disabled
                  v-model="comList1"
                  :data="communityList1"
                  placeholder="请选择"
                  clearable
                  @on-change="communityChange1"
                ></Cascader>
              </form-item>
            </i-col>
            <i-col span="6">
              <form-item label="面积" prop="landarea">
                <Input readonly v-model="query.landarea" clearable placeholder="请先绘制区域">
                  <span slot="append">m<sup>2</sup></span>
                </Input>
              </form-item>
            </i-col>
          </row>
          <row>
            <i-col span="24">
              <form-item label="备注" prop="landtips">
                <Input readonly
                  type="textarea"
                  v-model="query.landtips"
                  clearable
                  placeholder="请输入"
                />
              </form-item>
            </i-col>
          </row>
        </i-form>

        <div class="mapbox">
          <div class="mapboxtitle">
            <span>地图范围</span>
            <!-- <span @click="huizhi">绘制</span> -->
          </div>
          <div class="mapinfo">
            <div id="currentmap"></div>
          </div>
        </div>
      </div>

    </div>
    <Modal  v-model="modal1" title="绘制区域" width="1140" height="500" draggable>
        <div class="map-wrapper">
          <div  id="studentmaps">

          </div>
          <div id="clear" class="clearbtn box box_center ac"><span class="iconfont icon-fl-shuazi"></span></div>
        </div>

        <div slot="footer">
            <Button type="info"  @click="docancel">取消</Button>
            <Button type="success"  @click="dosure">确认</Button>
        </div>
    </Modal>



  </div>
</template>

<script>
var map = null
var mouseTool=null
var currentmap=null
import pageHead from "../../../components/head";
import PreviewImg from "../../../components/previewImg";
import api from "../../../api/index";
const {

} = api;
export default {
  name: "landnumdetail",
  components: {
    pageHead,
    PreviewImg,
  },

  data() {
    return {
      title:'地丘详情',
      header: {
        token: window.sessionStorage.getItem("token"),
      },
      btnList: [],
      query:{
        landnum:"",
        landtips:'',
        landnumname:"",
        landarea:"",
        communityId1:""
      },
      communityList1: [],
      comList1: [],
      selectedList:[],
      isCommittype:[
        {index: 0,type: "否"},
        {index: 1,type: "是"}
      ],
      typeList: [
        {index: 0,type: "市城区户籍自购商品房"},
        {index: 1,type: "非市城区户籍自购商品房"},
        {index: 2,type: "市城区户籍自建房"},
        {index: 3,type: "市城区户籍祖辈房产"},
        {index: 4,type: "市城区户籍租房"},
        {index: 5,type: "非市城区户籍租房"},
        {index: 6,type: "非市城区户籍祖辈房产"},
        {index: 7,type: "无购房无租房"}
      ],
       modal1:false,
       path:[],
       area:''
    };
  },
  methods: {
    formateData(data) {
      let returnData = data.map((item) => {
        return {
          value: {
            communityId: item.communityId,
            childrenIdList: item.childrenIdList,
          },
          label: item.communityName,
          children: item.children.length ? this.formateData(item.children) : [],
        };
      });
      return returnData;
    },
    communityChange1(value) {
      let returndata = value[value.length - 1];
      this.query.communityId1 = returndata.communityId;
    },
    getCommunity1() {
      this.$get(this.urlobj.getCommunityCascade, {
        communityId: this.$store.state.streetorcommunityid,
        nationwide: 1,
        lowestLevelId: 10000007770007,
      })
        .then((res) => {
          this.communityList1 = res.rows.length
            ? this.formateData(res.rows)
            : [];
          console.log(this.communityList1);
        })
    },
    initMap(){
        let that = this
        map = new AMap.Map('studentmaps', {
            zoom: 12,
            center:[115.041299,35.768234],
            mapStyle: "amap://styles/7048634155f3b6e2e1eaffe31697ebaf",
        });

        let polygon = new AMap.Polygon({
            path:that.path,
            fillColor: '#00b0ff', // 多边形填充颜色
            fillOpacity:0.4,
            borderWeight:0.5, // 线条宽度，默认为 1
            strokeColor: '#80d8ff', // 线条颜色
        });
        map.add(polygon);
        mouseTool = new AMap.MouseTool(map);
        //监听draw事件可获取画好的覆盖物
        var overlays = [];
        mouseTool.on('draw',function(e){
            overlays.push(e.obj);
        })

        function draw(){
          mouseTool.polygon({
            fillColor:'#00b0ff',
            strokeColor:'#80d8ff'
            //同Polygon的Option设置
          });
        }
        draw()
        AMap.event.addListener( mouseTool,'draw',function(e){
            console.log(e.obj.getPath());//获取路径/范围
            let pathlist=e.obj.getPath()
            let path=[]
            if(pathlist.length>0){
              for(let i=0;i<pathlist.length;i++){
                path.push(new AMap.LngLat(pathlist[i].lng,pathlist[i].lat))
              }
            }
            console.log(path)
            that.path=path
            that.area = Math.round(AMap.GeometryUtil.ringArea(path));
        });

        document.getElementById('clear').onclick = function(){
            map.remove(overlays)
            overlays = [];
            that.path=[]
            that.area =""
            polygon.hide()
        }
    },
    initMap1(){
      let that = this
          currentmap = new AMap.Map('currentmap', {
              zoom: 12,
              center:[115.041299,35.768234],
              mapStyle: "amap://styles/7048634155f3b6e2e1eaffe31697ebaf",
          });
          new AMap.DistrictSearch({
              subdistrict: 0,   //返回下一级行政区
              extensions: 'all',  //返回行政区边界坐标组等具体信息
              level: 'city'  //查询行政级别为 市center
          }).search("濮阳市", function (status, result) {
            console.log(result)
              console.log(result.districtList[0].center)
          });
          console.log(that.path)
          let polygon = new AMap.Polygon({
              path:that.path,
              fillColor: '#00b0ff', // 多边形填充颜色
              fillOpacity:0.4,
              borderWeight:0.5, // 线条宽度，默认为 1
              strokeColor: '#80d8ff', // 线条颜色
          });
          currentmap.add(polygon);
    },
    goedit(){
      this.$router.push({
        name: "landnumadd",
        query: {type:'edit'}
      });
    },
    docancel(){
      this.modal1=false
      if(mouseTool){
        mouseTool.close(true)
      }
       map && map.destroy();
    },
    dosure(){
      this.modal1=false
      this.query.landarea=this.area
      map && map.destroy();
      currentmap && currentmap.destroy();
      this.$nextTick(()=>{
        this.initMap1()
      })
    },
    huizhi(){
      this.modal1=true
      this.$nextTick(()=>{
        this.initMap()
      })
    },
    handleBtn(type) {

    },

  },
 destroyed() {
      console.log('销毁地图')
      currentmap && currentmap.destroy();
  },
  created() {
    this.getCommunity1();
  },
  mounted() {
    this.initMap1()
  },
};
</script>

<style  scoped lang="less">

  .contain{height: 100%;}
.content {
  margin:0 20px 20px 20px;background: #FFFFFF;height: calc(100% - 110px);display: flex;display: -webkit-flex;flex-direction: column;
}
.toptitle{width: 100%;height: 60px;border-bottom: solid 1px #DDDDDD;}
.toptitle span:nth-child(1){font-weight: bold;color: #4B4B4B;margin-left: 20px;font-size: 18px;}
.toptitle span:nth-child(2){width: 60px;height: 28px;background: #FF7C43;border-radius: 4px;text-align: center;line-height: 28px;font-size: 14px;color: #FFFEFE;margin-right: 20px;}
.toptab{width: 100%;display: flex;display: -webkit-flex;justify-content: space-between;border-bottom: solid 1px #EEEEEE;}
.toptableft{width: 100%;display: flex;display: -webkit-flex;}
.toptableft span{width: 86px;height: 32px;text-align: center;line-height: 32px;font-size: 16px;}
.bottombtn{width:150px;text-align: center;height:32px;line-height:32px;font-size: 16px;color: #FFFFFF;border-radius: 6px;background: #0097FF;}
.activetap{background: #FF7B44;color: #FFFFFF;border-radius: 6px 6px 0 0;}
.nomaltap{background: #FFFFFF;color: #666666;border-radius: 6px 6px 0 0;border: solid 1px #EEEEEE;}
.search {width: 100%;background-color: white;border-radius: 5px;padding:20px 20px 0 20px;margin-bottom: 20px;display: flex;display: -webkit-flex;flex-direction: column;flex: 1;}

.label {width: 100px;}
.time {width: 100%;}
.bottomtable{width: 100%;padding:20px;}
.table-data {
  width: 100%;
  background-color: white;
  border-radius: 5px;
  // padding: 20px;
  min-height: calc(100vh - 450px);
  .page {width: 100%;padding-bottom:20px;display: flex;justify-content: center;}
  .success {color: #ff7b44;}
  .action {color: #5e6d94;cursor: pointer;margin-right: 10px;}
}

.statistics {padding: 10px 0;text-align: right;}

.estateTitle {color: #ff7b44;font-weight: bold;}

.estateNO {color: #ff7b44;font-weight: 400;background: #ffefe9;margin: 0 15px 10px 0;}
.topformbox{width: 100%;background: #F8F8F8;height: 80px;border-radius: 4px 4px 0px 0px;display: flex;display: -webkit-flex;align-items: center;justify-content: space-between;}
.topformbox .ivu-form{width: 100%;height: 80px;display: flex;display: -webkit-flex;align-items: center;}
.topformbox .ivu-form .ivu-form-item{margin: 0;width: 360px;}
.topformbox .ivu-form .ivu-form-item:nth-child(1){margin-left: 21px;}
.topformboxright{height: 80px;display: flex;display: -webkit-flex;align-items: center;}
.topformboxright span:nth-child(1){width: 92px;height: 28px;background: #FF7943;border-radius: 4px;text-align: center;line-height: 28px;font-size: 14px;color: #FFFFFF;margin-right: 20px;}
.topformboxright span:nth-child(2){width:120px;height: 28px;background: #F9FAFA;border: 1px solid #DEDEDE;border-radius: 4px;text-align: center;line-height: 28px;font-size: 14px;color: #4B4B4B;margin-right: 20px;}

.schoolbox{width: 100%;height: 100%;}

.mapbox{width: 100%;display: flex;display: -webkit-flex;flex-direction: column;flex: 1;}
.mapboxtitle{height: 28px;display: flex;display: -webkit-flex;align-items: center;flex: 1;}
.mapboxtitle span:nth-child(1){font-size: 16px;font-weight: 400;color: #4B4B4B;}
.mapboxtitle span:nth-child(2){width: 60px;height: 28px;background: #FF7C43;border-radius: 4px;text-align: center;line-height: 28px;font-size: 14px;color: #FFFFFF;margin-left: 10px;}

.mapinfo{width: 870px;margin-left:84px;height: 100%;margin-top:-20px;}
#currentmap{width: 870px;height: 100%;}
.map-wrapper{width: 1099px;height: 643px;margin: 0 auto;background: #E1E1E1;position: relative;}
#studentmaps{width: 1099px;height: 643px;}
.clearbtn{width: 65px;height: 65px;background: rgba(255, 255, 255, 0.9);border: 1px solid #FFFFFF;box-shadow: 0px 2px 6px 0px rgba(12, 3, 7, 0.35);
    border-radius: 50%;position: absolute;bottom: 14px;right: 20px;}
.clearbtn span{font-size: 32px;color: #828282;transform:rotate(30deg);
-ms-transform:rotate(30deg); 	/* IE 9 */
-moz-transform:rotate(30deg); 	/* Firefox */
-webkit-transform:rotate(30deg); /* Safari 和 Chrome */
-o-transform:rotate(30deg);}
</style>
